import { env } from '../Utils/env'

import  {  useEffect,useContext, useState,SetStateAction } from "react";
import { setBoolFn,IAsaSessionState,IAsaSession,SessionPage,IAsaSecureSession} from '../types/types'
import { AsaStateContext } from '../components/AsaStateProvider'
import {useAsaQuery,callApiPut, callApiPost, callApiGet,prefetchFintechLayout } from './AsaApiServices'
import {AsaLoadingContext} from '../components/AsaSessionContext'
import {UseQueryResult, QueryClient,  useQuery, useQueryClient,
  useMutation,UseMutationResult,useIsFetching,useIsMutating } from "react-query";
import { Config } from '../Utils/AppConstants';
import { NavigateFunction } from 'react-router-dom';
import { AxiosError } from 'axios';

const STORAGE_KEY="AsaSecureSession"

function useAsaSession(setLoading:setBoolFn | undefined=undefined, setError:setBoolFn | undefined=undefined):UseQueryResult<IAsaSession, any>{
    const [state, _] = useContext(AsaStateContext)

    const res=useAsaQuery<IAsaSession>(['Session',state.sessionID],
      env.REACT_APP_API_URL + `AsaSession?asaSessionCode=${state.sessionID}`
      ,setLoading,setError,
      (v)=>!!(state && state.sessionID)
    )
    
    return res;
    
  }

  export const updateSessionPages = async( asaState:IAsaSessionState,toUpdate:IAsaSession,extraPages:SessionPage[] | null=null )=>{
    const toUpdateclone={...toUpdate}
    if(toUpdate.sessionPages  ){ 
      toUpdateclone.sessionPages=[...toUpdate.sessionPages]
    }
    if(extraPages){  // we are in mode just add new pages
      toUpdateclone.sessionPages=[...extraPages]
      var pagecount=parseInt(toUpdateclone.pageCount)
      toUpdateclone.sessionPages.forEach((page,idx)=>{
        if(!page.pageNumber){
          page.pageNumber=(pagecount-1+idx).toString()
        }
      })
      toUpdateclone.pageCount+=extraPages.length
    }
    try {
      const response = await callApiPut(
        env.REACT_APP_API_URL + `AsaSession`,
        asaState,
        toUpdateclone
      );
      return response;
    } catch (error) {
      throw error;
    }
    finally {
     
    }
  }
  interface ISessionUpdateArgs{
    asaState:IAsaSessionState,
    data: any,
    pageNumber: number,
    pageName: string,
    pageTitle: string,
    pageDescription: string,
    pageUrl: string,
    pageStatusMessage: string,
    pageCount:number,
    statusMessage:string,
    sessionName:string ,
    status:string,
    pageStatus:string
  }
  export const updateSession = async (
    asaState:IAsaSessionState,
    data: any,
    pageNumber: number,
    pageName: string,
    pageTitle: string,
    pageDescription: string,
    pageUrl: string,
    pageStatusMessage: string,
    pageCount:number,
    statusMessage:string,
    sessionName:string ="ASAVAULT-ONEGOAL",
    status:string ="Incomplete",
    pageStatus:string ="Complete"
  ) => {
  
   
    const updateRequest: SessionUpdateRequest = {
      asaSessionCode: `${asaState.sessionID}`,
      asaConsumerCode: asaState.asaConsumerCode??0,
      version: asaState.versionCode.toString(),
      sessionName: sessionName,
      pageCount: pageCount,
      status: status,
      statusMessage: statusMessage,
      sessionPages: [
        {
          asaSessionCode: `${asaState.sessionID}`, // Use the session ID
          pageNumber: pageNumber, // Page number, could be a string or a number depending on your API requirements
          pageName: pageName, // Name of the page (e.g., "Landing")
          pageTitle: pageTitle, // Title of the page (e.g., "Select Package")
          pageDescription: pageDescription, // Description of the page
          pageUrl: pageUrl, // URL of the page
          pageStatus: pageStatus, // Status of the page (e.g., "New")
          pageStatusMessage: pageStatusMessage, // Status message for the page
          pageData: JSON.stringify(data), // Serialize the selected plan data
        },
      ],
    };
  
    try {
  
      const response = await callApiPut(
        env.REACT_APP_API_URL + `AsaSession`,
        asaState,
        updateRequest
      );
     
      return response;
    } catch (error) {
      throw error;
    }
    finally {
     
    }
  };
  interface IUpdateSessionPagesArg{
    asaSession:IAsaSession
    extraPages:SessionPage[] | null
  }
  function useAsaSessionPagesMutation( ):UseMutationResult<any, any, IUpdateSessionPagesArg, any>{
    const  [state, ] = useContext(AsaStateContext)
    const queryclient =useQueryClient()
    const mutation=useMutation<any,any,IUpdateSessionPagesArg,any>({
      mutationFn: (arg:IUpdateSessionPagesArg) =>
         updateSessionPages(state,arg.asaSession,arg.extraPages),
        //TO do validate backend, potentially queryclient.setquerydata(.....)
        onSuccess:(response) =>invalidateAsaSession(queryclient,state.sessionID??0,response)
      })
    return mutation;
  }
  
  function useAsaSessionMutation( ):UseMutationResult<any, any, ISessionUpdateArgs, any>{
    const  [state, ] = useContext(AsaStateContext)
    const queryclient =useQueryClient()
    const mutation=useMutation<any,any,ISessionUpdateArgs,any>({
      mutationFn: (updateSessionArgs:ISessionUpdateArgs  ) =>
         updateSession(
          state,
          updateSessionArgs.data,
          updateSessionArgs.pageNumber,
          updateSessionArgs.pageName,
          updateSessionArgs.pageTitle,
          updateSessionArgs.pageDescription,
          updateSessionArgs.pageUrl,
          updateSessionArgs.pageStatusMessage,
          updateSessionArgs.pageCount,
          updateSessionArgs.statusMessage,
          updateSessionArgs.sessionName,
          updateSessionArgs.status,
          updateSessionArgs.pageStatus,
        ),
        //TO do validate backend, potentially queryclient.setquerydata(.....)
        onSuccess:(response) =>invalidateAsaSession(queryclient,state.sessionID??0,response)
      })
    return mutation;
  }
  const invalidateAsaSession=(queryclient:QueryClient | null,sessionId:number,response:any )=>{
    const queryKey=['Session',sessionId]

    if(!response){
      queryclient?.invalidateQueries({queryKey:queryKey})
      queryclient?.refetchQueries({queryKey:queryKey})
    }
    else{
      queryclient?.setQueriesData(queryKey,response)
    }
  }
  function generateRandomString() {
    var array = new Uint32Array(28);
    window.crypto.getRandomValues(array);
    return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('');
}
// Calculate the SHA256 hash of the input text. 
// Returns a promise that resolves to an ArrayBuffer
function sha256(plain:string):Promise<ArrayBuffer> {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
}

// Base64-urlencodes the input string
function base64urlencode(str:ArrayBuffer):string {
  return btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(str)))).replace('=', '')

}

// Return the base64-urlencoded sha256 hash for the PKCE challenge
async function pkceChallengeFromVerifier(str:string) {
  const hashed = await sha256(str);
  return base64urlencode(hashed);
}
function useIsLoading ():[boolean,React.Dispatch<SetStateAction<boolean>>]{
  const [isContecxLoading,setIsContecxLoading ] = useContext(AsaLoadingContext)

  const isFetching = useIsFetching()
  const isMutating =useIsMutating()
  const isLoading=isFetching>0 || isMutating>0 || isContecxLoading
  
  return [isLoading,setIsContecxLoading]
}
function getParamCaseInsensitive(searchParams : URLSearchParams, key : string ):string|null {
  const lowerCaseKey = key.toLowerCase();
  for (const [key, value] of searchParams.entries()){
    if (key.toLowerCase() === lowerCaseKey) {
      return value;
    }
  }
  return null;
}

function useMainAsaSession(setLoading:setBoolFn | undefined=undefined, 
  setError:setBoolFn | undefined=undefined):IAsaSecureSession{
    const [state, setState] = useContext(AsaStateContext)
    const [secureSession,setSecureSesssion]=useState<IAsaSecureSession>(JSON.parse(localStorage.getItem(STORAGE_KEY) || '0') || {}  )
    const currentUrl = new URL(window.location.href);
    const isEmptyParam=!currentUrl.searchParams || !currentUrl.searchParams.size || currentUrl.searchParams.size===0
    const newSessionId=parseInt(currentUrl.searchParams.get("sessionid")|| '')

    useEffect(()=>{
        
        if(isEmptyParam) 
          return;
        
        const load=async()=>{
          
          if(isNaN(newSessionId)){
            return
          }
          const isSessionChanged=newSessionId!==state.sessionID
          const newstate:IAsaSessionState = isSessionChanged?{} as IAsaSessionState:{ ...state }
          if(isSessionChanged){
          
            setState({} as IAsaSessionState)  //reset state
            setSecureSesssion({} as IAsaSecureSession)
            localStorage.setItem(STORAGE_KEY,JSON.stringify({}))
          }
          newstate.sessionID = newSessionId

          if(!newstate.codeVerifier || !newstate.codeChallenge){
            newstate.codeVerifier=generateRandomString();
            newstate.codeChallenge= await pkceChallengeFromVerifier(newstate.codeVerifier);
          }
          
          newstate.url=window.location.href
          const darkModeparam= getParamCaseInsensitive(currentUrl.searchParams, 'darkmode')
         
          if(!!darkModeparam){
           newstate.isDarkMode= newstate.isDarkMode=darkModeparam.toLowerCase()==="true"
          }
          //else if(newstate.url.toLowerCase().includes("asatransfer")){
          //  newstate.isDarkMode=false
          //} 
          
          //newstate.isDarkMode=newstate.url.toLowerCase().includes("darkmode=true") || !newstate.url.toLowerCase().includes("asatransfer");
          newstate.asaConsumerCode = parseInt(currentUrl.searchParams.get("asaConsumerCode") || '') || newstate.asaConsumerCode;
          newstate.versionCode = currentUrl.searchParams.get("version") || newstate.versionCode || '1.10';
          newstate.token = currentUrl.searchParams.get("token") || newstate.token;
          newstate.asaFintechcode = parseInt(currentUrl.searchParams.get("asaFintechCode") || '') || newstate.asaFintechcode;
          newstate.dynamicLink =  currentUrl.searchParams.get("dynamicLink") || newstate.dynamicLink;
          newstate.xAsaVersion=newstate.versionCode
          newstate.language=newstate.language??"en-US";
          
          Config.X_ASA_version=newstate.versionCode
          Config.token= newstate.token || Config.token
          Config.isLight=!newstate.isDarkMode
          if(JSON.stringify(state)!==JSON.stringify(newstate)){
             
              setState(newstate)
          }
        }
        load()
    },[window.location.href])

    
    useEffect(()=>{

      const loadSecureSession=async ()=>{
         
        try
        {
        
          setLoading?.(true)
          const validateBody={asaSessionCode:state.sessionID?.toString(),codeChallenge:state.codeChallenge,asaConsumerCode:state.asaConsumerCode}
          const basePublicUri=env.REACT_APP_API_URL?.replace('/asaconnect/','/public/')
          var sessionPreValidate=await callApiPost(basePublicUri+'SessionValidate',state,validateBody,false)
          var getSecureSession=await callApiGet<IAsaSecureSession>(basePublicUri + `SessionParam?asaSessionCode=${state.sessionID}&codeVerifier=${state.codeVerifier}`,state)
          setSecureSesssion(getSecureSession)
          localStorage.setItem(STORAGE_KEY,JSON.stringify(getSecureSession))
          if(getSecureSession.tokenTag && getSecureSession.subscriptionKey){

            const newstate:IAsaSessionState = { ...state }
            
            newstate.token=getSecureSession.tokenTag
            newstate.subscriptionKey=getSecureSession.subscriptionKey
            newstate.language=getSecureSession.language ?? newstate.language
            newstate.asaFintechcode=getSecureSession.asaFintechCode ?? newstate.asaFintechcode
            newstate.appCode=getSecureSession.fintechApplicationCode ?? newstate.appCode
            const version=parseFloat(getSecureSession.version || '' )

            newstate.versionCode=getSecureSession.version || newstate.versionCode
            newstate.xAsaVersion=newstate.versionCode
            newstate.error=null;
            Config.asaFintechCode=newstate.asaFintechcode??0
            Config.appCode=getSecureSession.fintechApplicationCode ?? newstate.appCode ??0
            Config.token=getSecureSession.tokenTag
            Config.subscriptionKey=getSecureSession.subscriptionKey
            Config.language=newstate.language?? "en-US"
            Config.X_ASA_version=newstate.versionCode
        
            if(!!!env.REACT_APP_SUBSCRIPTION){
              env.REACT_APP_SUBSCRIPTION=getSecureSession.subscriptionKey
            }
            if(JSON.stringify(state)!==JSON.stringify(newstate)){
              setState(newstate)
            }
          }else{
             const newstate:IAsaSessionState = { ...state }
             newstate.error="Can't obtain consumer token/subscription key. Please try again later."
             setState(newstate)
          }

          
        }
        catch(error){
          console.log(error)
          const errorUrl= new URL(window.location.href)
          errorUrl.pathname='/fail' 
          const newstate:IAsaSessionState = { ...state }
          //newstate.error=error as string
          if (error instanceof AxiosError) {
            const err = error as AxiosError;
            if(err.response && err.response.status===401){
              newstate.error= "Unauthorized access. Please login again."
            }else{
              newstate.error="Error loading secure session. Please try again later."
            }

          }else{
            newstate.error="Unknown error occurred while loading secure session"
          }
           setState(newstate)

        }
        finally{
          setLoading?.(false)
        }
      }
      const currentUrl = new URL(window.location.href);
      let isTokenObtained=!!currentUrl.searchParams.get("token") || !!state.token;


      if(!isTokenObtained && 
          ( state.sessionID 
          && state.codeChallenge
          && state.sessionID===newSessionId 
          && (secureSession?.asaSessionCode!==state.sessionID?.toString() || !secureSession?.tokenTag)
          ) 
          || 
          (state.error!==null  && state.sessionID===newSessionId )
        ){
          loadSecureSession()
        }
    },[state.sessionID,state.codeVerifier,state.codeChallenge,state.token])
   
    return secureSession;
  }
function useBackButton():()=>void{
  const {data:session}=useAsaSession()
  const handleBackClick = () => {

    const targetPage = session?.sessionPages?.find(page => page.pageNumber === 0);
    if (targetPage) {
      const pageData = JSON.parse(targetPage.pageData);
      const backActionDynamicLink = pageData.backActionDynamicLink;
      if (backActionDynamicLink) {
        window.location.href = backActionDynamicLink;
      } else {
            const currentUrl = new URL(window.location.href);
            const backLink = currentUrl.searchParams.get("dynamicLink")
            if( backLink ) {
              window.location.href = backLink;
            }
      }
    }

  };
  return handleBackClick
}
export {useAsaSession,useAsaSessionPagesMutation,useAsaSessionMutation,useMainAsaSession,useIsLoading,useBackButton}